import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import News from './News'

function Blog() {
    return (

        <div>
            <Navbar />

            <News />


            <Footer />
        </div>
    )
}

export default Blog